<template>
    <div class="yudo-it-other">
        <h1 class="header">{{ qrcode.attrs.name }}</h1>
        <h1 class="title">资产照片</h1>
        <div v-if="qrcode.attrs.img.path" class="img-prev">
            <van-image fit="contain" :src="imgUrl" alt="固定资产图片" @click="onImgPreview(imgUrl)" />
        </div>
        <div v-else class="img-placeholder">
            <span>[-资产图片-]</span>
        </div>
        <h1 class="title">资产信息</h1>
        <table class="info-table">
            <tbody>
                <tr>
                    <td>资产名称</td>
                    <td>{{ qrcode.attrs.name }}</td>
                </tr>
                <tr>
                    <td>部门</td>
                    <td>{{ qrcode.attrs.department }}</td>
                </tr>
                <tr>
                    <td>设备编号</td>
                    <td>{{ qrcode.attrs.number }}</td>
                </tr>
                <tr>
                    <td>型号规格</td>
                    <td>{{ qrcode.attrs.model }}</td>
                </tr>
                <tr>
                    <td>IP地址</td>
                    <td>{{ qrcode.attrs.ip }}</td>
                </tr>
                <tr>
                    <td>购买日期</td>
                    <td>{{ qrcode.attrs.buy_time }}</td>
                </tr>
                <tr>
                    <td>保修时间</td>
                    <td>{{ qrcode.attrs.warranty_time }}</td>
                </tr>
                <tr>
                    <td>保修到期时间</td>
                    <td>{{ qrcode.attrs.warranty_end_time }}</td>
                </tr>
                <tr>
                    <td>供应商</td>
                    <td>{{ qrcode.attrs.supplier }}</td>
                </tr>
                <tr>
                    <td>耗材型号</td>
                    <td>{{ qrcode.attrs.consumable }}</td>
                </tr>
            </tbody>
        </table>
        <!-- 操作 -->
        <template v-if="qrcode.org_id > 0">
            <h1 class="title">盘点相关</h1>
            <van-cell-group :border="false">
                <van-cell title="盘点操作" :border="false" center is-link :to="{ name: 'YUDOCheck' }" />
                <van-cell title="盘点记录" :border="false" center is-link :to="{ name: 'YUDOCheckRecord' }" />
            </van-cell-group>
            <h1 class="title">维修相关</h1>
            <van-cell-group :border="false">
                <van-cell title="维修操作" :border="false" center is-link :to="{ name: 'YUDORepair' }" />
                <van-cell title="维修记录" :border="false" center is-link :to="{ name: 'YUDORepairRecord' }" />
            </van-cell-group>
        </template>
        <template v-else>
            <h1 class="title">盘点相关</h1>
            <van-cell-group :border="false">
                <van-cell title="盘点操作" :border="false" center is-link />
                <van-cell title="盘点记录" :border="false" center is-link />
            </van-cell-group>
            <h1 class="title">维修相关</h1>
            <van-cell-group :border="false">
                <van-cell title="维修操作" :border="false" center is-link />
                <van-cell title="维修记录" :border="false" center is-link />
            </van-cell-group>
        </template>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';

export default {
    name: 'YUDOItOther',
    props: {
        qrcode: {
            type: Object,
            default: () => {
                return { attrs: {} };
            },
        },
        tpl: {
            type: Object,
        },
    },
    data() {
        return {};
    },
    computed: {
        // 产品照片
        imgUrl() {
            return process.env.VUE_APP_STATIC_HOST + this.qrcode.attrs.img.path;
        },
    },
    mounted() {},
    methods: {
        // 图片预览
        onImgPreview(url) {
            ImagePreview({ images: [url], closeable: true });
        },
    },
};
</script>
<style lang="less" scoped>
.yudo-it-other {
    padding: 16px 16px 0 16px;
    background-color: #fff;
    .header {
        padding: 40px 0;
        margin: -16px -16px 0 -16px;
        text-align: center;
        background-color: #409eff;
        color: #fff;
        font-size: 20px;
    }
    .title {
        padding: 10px 8px;
        margin: 16px 0;
        border-left: 5px solid #409eff;
        background-color: #ebeef5;
        color: #303133;
        font-size: 14px;
    }
    .img-prev {
        width: 100%;
        img {
            width: 100%;
        }
    }
    .img-placeholder {
        width: 100%;
        padding: 40px 0;
        background-color: #e4e7ed;
        text-align: center;
        span {
            font-size: 16px;
            color: #909399;
        }
    }
    .info-table {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #dcdfe6;
        font-size: 14px;
        color: #606266;
        td {
            width: 40%;
            padding: 8px;
            border: 1px solid #dcdfe6;
            &:last-child {
                width: 60%;
            }
        }
        .van-tag {
            margin-right: 4px;
        }
    }
    .van-cell-group {
        .van-cell {
            margin: 16px 0;
            border: 1px solid #dcdfe6;
            color: #606266;
        }
    }
}
</style>